import "./ChatPage.scss";
import type React from "react";
import {useEffect, useRef} from "react";
import {Box} from "@mui/material";
import {MainFooter} from "../../components/main/MainFooter.tsx";
import {ChatArea} from "./components/ChatArea";
import {Sidebar} from "./components/Sidebar";
import {useSearchParams} from "react-router";
import {useChatContext} from "./context/ChatContext";
import {LoadingBarComponent} from "../../components/loading-bar/LoadingBarComponent.tsx";

export const ChatPage: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const {currentSession, restoreSession, sessions} = useChatContext();
    const hasRestoredRef = useRef(false);

    // Restore session from URL on mount (wait for sessions to be loaded)
    useEffect(() => {
        const sessionIdFromUrl = searchParams.get('session_id');
        if (sessionIdFromUrl && !currentSession && !hasRestoredRef.current && sessions.length > 0) {
            hasRestoredRef.current = true;
            restoreSession(sessionIdFromUrl);
        }
    }, [searchParams, sessions]);

    // Update URL when session changes
    useEffect(() => {
        if (currentSession?.id) {
            const currentSessionId = searchParams.get('session_id');
            if (currentSessionId !== currentSession.id) {
                setSearchParams({session_id: currentSession.id}, {replace: true});
            }
        } else if (currentSession === null) {
            // New chat - remove session_id from URL
            const currentSessionId = searchParams.get('session_id');
            if (currentSessionId) {
                setSearchParams({}, {replace: true});
            }
        }
    }, [currentSession]);

    // return <MainPageFacade
    //     title={CARD_CONFIG['chat'].title}
    //     titlePostfix={<BetaPill/>}
    //     className="chat-page">
    //     ...
    // </MainPageFacade>

    // Uses a custom version of the <MainPageFacade/> to better suit the chat page layout
    return <>
        <LoadingBarComponent/>
        <main id="main-component-content">
            <div id="main-page-facade" className="chat-page">
                <Box className="chat-page-content" sx={{
                    display: 'flex',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    overflow: 'hidden',
                }}>
                    <Sidebar/>
                    <Box sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}>
                        <ChatArea/>
                        <footer id="main-component-footer"><MainFooter/></footer>
                    </Box>
                </Box>
            </div>
        </main>
    </>
}
